<script>
  import { NavItem, NavLink, Tooltip } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';

  import { generateUUID } from '@common/utils/strings';

  /** @type {boolean} */
  export let active = false;
  /** @type {boolean} */
  export let collapse = false;
  /** @type {string | undefined} */
  export let icon = undefined;
  /** @type {'sm' | undefined} */
  export let size = undefined;

  const id = `tab-${generateUUID()}`;
</script>

<NavItem>
  <NavLink class="mx-0 {size === 'sm' ? 'small' : ''}" {active} {id} on:click>
    <Icon name={icon} />
    {#if !collapse || active}
      <span class="ms-1 text-capitalize">
        <slot />
      </span>
    {/if}
  </NavLink>
</NavItem>

{#if collapse && !active}
  <Tooltip target={id} placement="bottom">
    <slot />
  </Tooltip>
{/if}
